import Quill from 'quill-next';
import { ListeningArticleEnBlock } from './blots/listening-article-en';
import { ListeningArticleCnBlock } from './blots/listening-article-cn';
import { ListeningArticleContainerBlock } from './blots/listening-article-container';
import './listening-article.less';
import { findAllContainer, findAllEn, getStatus } from './utils';
import { ListeningArticleHighlight } from './blots/listening-article-highlight';

const Module = Quill.import('core/module');

ListeningArticleEnBlock.requiredContainer = ListeningArticleContainerBlock;
ListeningArticleCnBlock.requiredContainer = ListeningArticleContainerBlock;

ListeningArticleContainerBlock.allowedChildren = [ListeningArticleCnBlock, ListeningArticleEnBlock, ListeningArticleHighlight];

export class ListeningArticle extends Module {
  private id = 'listening-article';

  private _showTranslate = false;

  static register() {
    Quill.register(ListeningArticleContainerBlock, true);
    Quill.register(ListeningArticleEnBlock, true);
    Quill.register(ListeningArticleCnBlock, true);
    Quill.register(ListeningArticleHighlight, true);
  }

  // 翻译
  showTranslate(value: boolean) {
    this._showTranslate = !!value;
    findAllContainer(this.quill.editor.scroll).forEach((blot) => {
      const b = blot as unknown as ListeningArticleContainerBlock;
      if (b.children.tail.statics.blotName === 'listening-article-cn') {
        if (b.status === 'playing') {
          if (value) {
            b.children.tail.show();
          } else {
            b.children.tail.hide();
          }

        }
      }
    });
  }

  scrollTo(order: number) {
    let found = false;
    findAllContainer(this.quill.editor.scroll).forEach((blot) => {
      if (found) {
        return;
      }
      const b = blot as unknown as ListeningArticleContainerBlock;
      if (b.order === order) {
        found = true;
        b.scrollTo();
      }
    });
  }

  updateActive(currentTime: number) {
    // console.log('progress', currentTime);
    let found = false;
    findAllContainer(this.quill.editor.scroll).forEach((blot) => {
      const b = blot as unknown as ListeningArticleContainerBlock;
      const newStatus = getStatus(currentTime, b, found);
      b.updateStatus(newStatus);
      if (newStatus === 'playing') {
        found = true;
      }
      if (newStatus === 'playing' && this._showTranslate) {
        if (b.children.tail.statics.blotName === 'listening-article-cn') {
          b.children.tail.show();
        } else {
          b.children.tail.hide();
        }
      }
    });
  }

  findEn(index: number): ListeningArticleEnBlock | undefined {
    return findAllEn(this.quill.editor.scroll).find((blot) => {
      return Number((blot.domNode as HTMLElement).dataset.order) === index;
    }) as (ListeningArticleEnBlock | undefined);
  }

}

Quill.register({
  'modules/listeningArticle': ListeningArticle,
});
ListeningArticle.register();
